var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSogehts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 81",
    style: {
      enableBackground: "new 0 0 100 81"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00467D;}\r\n\t.st1{enable-background:new    ;}\r\n\t.st2{fill:#00C713;}\r\n\t.st3{fill:none;}\r\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:2;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sogehts",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Differenzmenge_22",
    className: "st0",
    d: "M100,81H40.5C18.1,81,0,62.9,0,40.5S18.1,0,40.5,0H100V81z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_702"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45,41.5v1.4c0,0.4-0.2,0.6-0.6,0.6h-1.7c-0.4,0-0.6-0.2-0.6-0.6v-1.3c0-1,0.2-1.8,0.5-2.4 c0.3-0.6,0.9-1.2,1.7-1.9l1.7-1.4c1-0.8,1.5-1.7,1.5-2.8v-0.8c0-2.3-1.1-3.4-3.4-3.4h-1.4c-2.2,0-3.4,1.1-3.4,3.4v1.4 c0,0.4-0.2,0.6-0.6,0.6H37c-0.3,0-0.5-0.2-0.5-0.6v-1.5c0-1.8,0.5-3.3,1.6-4.3s2.5-1.5,4.3-1.5h2.1c1.8,0,3.3,0.5,4.3,1.5 c1.1,1,1.6,2.5,1.6,4.3v1c0,1.4-0.6,2.6-1.9,3.6l-2.1,1.8c-0.6,0.5-1,1-1.2,1.4C45,40.3,45,40.9,45,41.5z M45,46.6v4.8 c0,0.4-0.2,0.6-0.5,0.6h-2c-0.3,0-0.5-0.2-0.5-0.6v-4.8c0-0.3,0.2-0.5,0.5-0.5h2C44.9,46.1,45,46.3,45,46.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_233",
    transform: "translate(20.999 16.999)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 22.5,
    cy: 22.5,
    r: 22.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 22.5,
    cy: 22.5,
    r: 21.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSogehts);
export default __webpack_public_path__ + "static/media/sogehts.9a33b9d760f5527202f39d45c9579774.svg";
export { ForwardRef as ReactComponent };